import React, { FC, useContext } from 'react';
import { Route, useRouteMatch } from 'react-router-dom'
import NavWrapper from '../components/wrappers/NavWrapper'
import InternalNavigation from '../pages/alarms/InternalNavigation'
import { userContext } from '../utils/userContext'

export interface RouteLocationProps {
    page: number
}

export class RouteLocationProps implements RouteLocationProps {
    constructor(page: number = 0) {
        this.page = page
    }
}

const AlarmsRouter: FC = () => {
    let match = useRouteMatch()
    const { hasModule } = useContext(userContext)

    return (
        <NavWrapper pageName="Alarmer">
            {!hasModule(match.url) ?
                <Route component={() => <div>Du har ikke adgang til SMS alarmer</div>}/>
            :
                <InternalNavigation />
            }
        </NavWrapper>
    )
}

export default AlarmsRouter
